import {Deserializable} from '../deserializable';
import {DonVi} from '../danhmuc/donvi';


export  class StaffDepartment implements Deserializable
{
  public  staffID: number;
  public  departmentID: number;
  public  donViItem: DonVi;
  deserialize(input: any): this {
    Object.assign(this, input);
    this.donViItem = input.donViItem !== null ? new DonVi().deserialize(input.donViItem) : null;
    return this;
  }
}
